<template>
		<div id="app">
				<router-view/>
		</div>
</template>

<script>

export default {
		name: 'App',

}
</script>
<style>
html body {
		margin: 0;
		padding: 0;
		
}
.el-table--border th.gutter:last-of-type {
  display: block!important;
}
.text_red{color: red;}

</style>
